import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
/**
 * scrollAnimation()
 *
 */
export const scrollAnimation = () => {
  const elements = gsap.utils.toArray('.js-scroll-view');
  elements.forEach((element) => {
    const scrollArgs = {
      start: 'top 80%',
      end: 'bottom top',
      trigger: element,
      onEnter: () => {
        element.classList.add('is-animated');
      },
    };
    if (element.classList.contains('fadeInUpward')) {
      gsap.fromTo(
        element,
        {
          y: 20,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          scrollTrigger: scrollArgs,
        }
      );
    } else {
      gsap.to(element, {
        scrollTrigger: scrollArgs,
      });
    }
  });
};
